import "./index.less";
import * as React from "react";
import { DefaultSizes, XL } from "../../../internal";
import cn from "classnames";

export interface IAtSubtitleProps {
    subtitle: string | React.ReactNode;
    size?: DefaultSizes | XL;
    className?: string;
}

export const AtSubtitle: React.FC<IAtSubtitleProps> = (props) => {
    const { className, subtitle, size, ...otherProps } = props;

    return (
        <div className={cn("AtSubtitle", className, { [`size-${size}`]: size })} {...otherProps}>
            {subtitle}
        </div>
    );
};
